module.exports = __webpack_public_path__ + "media/images/design/common/images/icon_allow-d1cf7a683f30b670142a04ae84810fd0.png";